module.exports = __webpack_public_path__ + "static/img/ChatBc.e2624f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/breadcrumb/ChatBc.png
// module id = FKPR
// module chunks = 1